// Add your JS customizations here
import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

document.addEventListener("DOMContentLoaded", () => {
	const hamburger = document.querySelector(".hamburger");
	hamburger.addEventListener("click", (e) => {
		e.currentTarget.classList.toggle("is-active");
		document.body.classList.toggle("menu-open");
	});

	document.querySelectorAll(".use-case__show-button").forEach((button) => {
		button.addEventListener("click", () => {
			const card = button.closest(".paragraph--type--use-case");
			const expanded = button.getAttribute("aria-expanded") !== "true";
			card.querySelector(".use-case__teaser").hidden = expanded;
			card.querySelector(".use-case__full").hidden = !expanded;
			button.textContent = expanded
				? button.dataset.labelLess
				: button.dataset.labelMore;
			button.setAttribute("aria-expanded", expanded);
		});
	});

	// Clicking anywhere on a use case card opens its link, except on the
	// button and on links, which handle themselves.
	document.querySelectorAll(".paragraph--type--use-case").forEach((card) => {
		const link = card.querySelector(".use-case__link");
		if (!link) {
			return;
		}
		card.addEventListener("click", (e) => {
			if (e.target.closest("a, button") || window.getSelection().toString()) {
				return;
			}
			link.click();
		});
	});
});

const dataItems = new Swiper("#dataItems", {
	modules: [Navigation, Pagination],
	slidesPerView: 1,
	breakpoints: {
		1000: {
			slidesPerView: 2,
		},
	},
	speed: 1000,

	navigation: {
		nextEl: ".dataItemsWrapper .swiper-button-next",
		prevEl: ".dataItemsWrapper .swiper-button-prev",
	},

	pagination: {
		el: ".dataItemsWrapper .swiper-pagination",
		clickable: true,
	},
});

const projectItems = new Swiper("#projectItems", {
	modules: [Navigation, Pagination],
	slidesPerView: 1,
	breakpoints: {
		1000: {
			slidesPerView: 2,
		},
	},
	speed: 1000,

	navigation: {
		nextEl: ".projectItemsWrapper .swiper-button-next",
		prevEl: ".projectItemsWrapper .swiper-button-prev",
	},

	pagination: {
		el: ".projectItemsWrapper .swiper-pagination",
		clickable: true,
	},
});
